import { render, staticRenderFns } from "./RiskDonutChart.vue?vue&type=template&id=01abbf0c&scoped=true&"
import script from "./RiskDonutChart.vue?vue&type=script&lang=js&"
export * from "./RiskDonutChart.vue?vue&type=script&lang=js&"
import style0 from "./RiskDonutChart.vue?vue&type=style&index=0&id=01abbf0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01abbf0c",
  null
  
)

export default component.exports